import React from 'react';

import { CuiOptionType, Dropdown } from '@crehana/ui';
import { useMe } from '@crehana/web/dist/ReactContexts/AuthContext';
import { useTranslation } from '@crehana/i18n';

import { useAppContext } from 'Jsx/Catalog/context/AppContext';

import { PREMIUM_FILTER_LINKS, PAYG_FILTER_LINKS } from '../contants';

interface FilterLinksMobileProps {
  className?: string;
}

const FilterLinksMobile: React.FC<FilterLinksMobileProps> = ({ className }) => {
  const { orderBy, filters, orderByActions, filterActions } = useAppContext();
  const { me, loading: loadingMe } = useMe();
  const { t } = useTranslation();

  const hasCategorySelected =
    !!filters.categorySelected?.itemId &&
    filters.categorySelected?.itemId !== 'null';

  if (loadingMe || hasCategorySelected) {
    return null;
  }

  const isPremium = me?.isPremiumMember;
  const items = isPremium ? PREMIUM_FILTER_LINKS : PAYG_FILTER_LINKS;
  const options: CuiOptionType<string>[] = items.map(item => ({
    value: item.value,
    label: t(item.label),
  }));

  const onSelectOrderOption = (option: CuiOptionType<string> | undefined) => {
    if (option) {
      filterActions.clearAllFilters();
      // @ts-expect-error
      orderByActions.selectOrderBy(option);
    }
  };

  return (
    <div className={className}>
      <Dropdown
        full
        options={options}
        selected={orderBy.itemSelected}
        onSelected={onSelectOrderOption}
      />
    </div>
  );
};

export default FilterLinksMobile;
